(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.announcement-bar__message'));
      this.index = this.messages.findIndex((message) => !message.hidden);
      if (this.index < 0) this.index = 0;
      this.messages.forEach((message, i) => {
        message.hidden = i !== this.index;
        message.classList.toggle('is-active', i === this.index);
      });

      this.prevButton = this.querySelector('.announcement-bar__nav--prev');
      this.nextButton = this.querySelector('.announcement-bar__nav--next');
      this.prevButton?.addEventListener('click', () => this.step(-1));
      this.nextButton?.addEventListener('click', () => this.step(1));

      // Autoplay runs only while nothing asks it to pause: pointer hover,
      // keyboard focus inside, a hidden tab, the shopper's pause button, or
      // a message block selected in the theme editor.
      this.autoplayMs = Number(this.dataset.autoplayMs);
      this.pauseReasons = new Set();
      if (document.hidden) this.pauseReasons.add('hidden');

      this.toggleButton = this.querySelector('[data-autoplay-toggle]');
      this.toggleButton?.addEventListener('click', () => {
        if (this.pauseReasons.has('user')) {
          this.pauseReasons.delete('user');
        } else {
          this.pauseReasons.add('user');
        }
        this.updateToggle();
        this.updateAutoplay();
      });

      this.addEventListener('pointerenter', () => this.pause('hover'));
      this.addEventListener('pointerleave', () => this.resume('hover'));
      this.addEventListener('focusin', () => this.pause('focus'));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.resume('focus');
      });

      this.onVisibilityChange = () => {
        if (document.hidden) {
          this.pause('hidden');
        } else {
          this.resume('hidden');
        }
      };
      this.onBlockSelect = (event) => {
        const index = this.messages.indexOf(event.target);
        if (index < 0) return;
        this.show(index);
        this.pause('editor');
      };
      this.onBlockDeselect = (event) => {
        if (this.messages.includes(event.target)) this.resume('editor');
      };
      this.onSectionUnload = (event) => {
        if (event.target.contains(this)) this.stopAutoplay();
      };

      document.addEventListener('visibilitychange', this.onVisibilityChange);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);

      this.updateAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
    }

    pause(reason) {
      this.pauseReasons.add(reason);
      this.updateAutoplay();
    }

    resume(reason) {
      this.pauseReasons.delete(reason);
      this.updateAutoplay();
    }

    updateAutoplay() {
      const shouldRun = this.autoplayMs > 0 && this.messages.length > 1 && this.pauseReasons.size === 0;
      if (shouldRun && !this.timer) {
        this.timer = setInterval(() => this.step(1), this.autoplayMs);
      } else if (!shouldRun) {
        this.stopAutoplay();
      }
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }

    updateToggle() {
      if (!this.toggleButton) return;
      const paused = this.pauseReasons.has('user');
      this.classList.toggle('is-user-paused', paused);
      this.toggleButton.setAttribute(
        'aria-label',
        paused ? this.toggleButton.dataset.labelPlay : this.toggleButton.dataset.labelPause
      );
    }

    // Jumps straight to a message without the slide (theme editor selection).
    show(index) {
      this.index = index;
      this.animating = false;
      this.messages.forEach((message, i) => {
        message.classList.remove('is-prev', 'is-next');
        message.classList.toggle('is-active', i === index);
        message.hidden = i !== index;
      });
    }

    // Slides the outgoing message out one side while the incoming message
    // slides in from the other, both absolutely stacked in the same box
    // (see .announcement-bar__message's position: absolute; inset: 0).
    // The incoming message starts hidden (display: none), so its
    // off-screen position has to be committed via a forced reflow before
    // switching to is-active, or the two style changes coalesce into one
    // and there's nothing for the transition to animate between.
    step(delta) {
      if (this.messages.length < 2 || this.animating) return;

      const outgoing = this.messages[this.index];
      this.index = (this.index + delta + this.messages.length) % this.messages.length;
      const incoming = this.messages[this.index];

      const outClass = delta > 0 ? 'is-prev' : 'is-next';
      const inClass = delta > 0 ? 'is-next' : 'is-prev';

      this.animating = true;
      incoming.classList.remove('is-active', 'is-prev', 'is-next');
      incoming.hidden = false;
      incoming.classList.add(inClass);
      void incoming.offsetWidth;
      incoming.classList.remove(inClass);
      incoming.classList.add('is-active');
      outgoing.classList.remove('is-active', 'is-prev', 'is-next');
      outgoing.classList.add(outClass);

      // Runs exactly once per step: whichever of transitionend / the timeout
      // fallback comes first wins. Without the guard, a late second call
      // could hide a message that a newer step() had already made active,
      // leaving the bar blank. transitionend bubbles (from links inside the
      // message, and fires once per transitioned property), so only the
      // incoming message's own event counts.
      let finished = false;
      const onTransitionEnd = (event) => {
        if (event.target === incoming) finish();
      };
      const finish = () => {
        if (finished) return;
        finished = true;
        clearTimeout(fallback);
        incoming.removeEventListener('transitionend', onTransitionEnd);
        outgoing.classList.remove('is-prev', 'is-next');
        if (outgoing !== this.messages[this.index]) outgoing.hidden = true;
        this.animating = false;
      };
      incoming.addEventListener('transitionend', onTransitionEnd);
      const fallback = setTimeout(finish, 550);
    }
  }

  if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const dialog = document.getElementById('cart-drawer');
    if (!dialog) return;

    const sectionId = dialog.dataset.sectionId;
    const cartUrl = dialog.dataset.cartUrl;
    const recommendationsBase = dialog.dataset.recommendationsBase;
    const giftWrapProductId = Number(dialog.dataset.giftWrapProductId) || 0;
    const errorEl = dialog.querySelector('[data-cart-drawer-error]');
    const liveEl = dialog.querySelector('[data-cart-drawer-live]');
    // The /cart page is a plain form; once the drawer changes the cart that
    // form is stale, so the page reloads when the drawer closes.
    const onCartPage = !!document.querySelector('[data-cart-page]');
    let cartPageDirty = false;

    // Queue state: key -> target. Keys are:
    // - a line item key (stepper): quantity, sent to /cart/change.js
    // - GIFT_KEY (gift wrap toggle): 1 adds the wrap variant, 0 removes
    //   every wrap line by line key, via /cart/update.js
    // - FIELDS_KEY (gift message / order note): { attributes, note }, via
    //   /cart/update.js
    // Every cart write goes through this single serial queue, so no two
    // writes are ever in flight at once and none can overwrite another.
    const GIFT_KEY = '__gift_wrap__';
    const FIELDS_KEY = '__fields__';
    const targets = new Map();
    let queueRunning = false;
    // Ordering: every request (refresh GET or queue POST) takes a sequence
    // number when it is *sent*. A response is only applied if it was sent
    // after whatever is currently on screen, so a slow older response can
    // never overwrite newer state, whichever code path produced it.
    let requestSeq = 0;
    let appliedSeq = 0;
    // `.is-loading` is driven by a counter of in-flight refreshes (always
    // decremented in `finally`), not by "whoever owns the latest token", so
    // it can never be left on after a refresh gets superseded.
    let loadingCount = 0;
    // A refresh sent while a queue POST is in flight may be answered from
    // cart state that predates that POST, so it can't be trusted: the queue
    // resyncs once more after it drains.
    let resyncAfterQueue = false;
    let announceTimer = null;
    let orphanAttempted = '';
    const REFRESH_TIMEOUT_MS = 15000;

    function routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function isGiftWrapItem(item) {
      return !!giftWrapProductId && item.product_id === giftWrapProductId;
    }

    /** Item count without gift wrap lines (wrap is not a bag item). */
    function itemCount(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;
      return cart.items.reduce((sum, item) => sum + (isGiftWrapItem(item) ? 0 : item.quantity), 0);
    }

    function applyFragment(doc, selector) {
      const fresh = doc.querySelector(selector);
      const live = document.querySelector(selector);
      if (fresh && live) live.replaceWith(fresh);
    }

    function giftToggle() {
      return dialog.querySelector('[data-gift-wrap-toggle]');
    }

    function syncHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
      // The notes block is not a swapped fragment (so typing survives a
      // refresh); only its visibility follows the cart.
      const notes = dialog.querySelector('[data-cart-drawer-notes]');
      if (notes) notes.hidden = count === 0;
    }

    function showError(message) {
      if (errorEl) errorEl.textContent = message || dialog.dataset.errorLabel;
    }

    function clearError() {
      if (errorEl) errorEl.textContent = '';
    }

    function captureFocus() {
      const active = document.activeElement;
      if (!active || !dialog.contains(active)) return null;
      if (active.matches('[data-gift-wrap-toggle]')) return { selector: '[data-gift-wrap-toggle]' };
      const stepper = active.closest('[data-qty-increase], [data-qty-decrease]');
      if (!stepper) return null;
      return {
        key: stepper.dataset.lineKey,
        attr: stepper.hasAttribute('data-qty-increase') ? 'data-qty-increase' : 'data-qty-decrease',
      };
    }

    /** The fragment swap replaces the focused control with a fresh copy;
        put focus back on the same control (or the nearest sensible one if
        its line was removed) so keyboard users keep their place. */
    function restoreFocus(saved) {
      if (!saved || !dialog.open) return;
      let target = null;
      if (saved.selector) {
        target = dialog.querySelector(saved.selector);
      } else {
        const escapedKey = window.CSS && CSS.escape ? CSS.escape(saved.key) : saved.key;
        target = dialog.querySelector(`[${saved.attr}][data-line-key="${escapedKey}"]`);
      }
      target =
        target ||
        dialog.querySelector('[data-qty-decrease], [data-qty-increase]') ||
        dialog.querySelector('[data-dialog-close]');
      if (target) target.focus();
    }

    function reapplyPendingTargets() {
      targets.forEach((value, key) => {
        if (key === FIELDS_KEY) return;
        if (key === GIFT_KEY) {
          const toggle = giftToggle();
          if (toggle) {
            toggle.checked = value > 0;
            toggle.disabled = true;
          }
          return;
        }
        const escapedKey = window.CSS && CSS.escape ? CSS.escape(key) : key;
        const line = dialog.querySelector(`[data-cart-line][data-line-key="${escapedKey}"]`);
        const qtyEl = line && line.querySelector('[data-qty-value]');
        if (qtyEl) qtyEl.textContent = value;
        if (line) line.classList.add('is-pending');
      });
    }

    function announce() {
      const source = dialog.querySelector('[data-cart-drawer-live-source]');
      if (!liveEl || !source) return;
      const message = source.textContent.trim();
      // Clear, then set on a later task: setting identical text in the same
      // tick is not a DOM change, so screen readers would skip a repeat total.
      clearTimeout(announceTimer);
      liveEl.textContent = '';
      announceTimer = setTimeout(() => {
        liveEl.textContent = message;
      }, 120);
    }

    /** A cart holding only gift wrap is an empty cart: the server renders
        it as empty and flags the wrap fragment; remove the wrap through the
        queue. Attempted once per set of line keys so a failure can't loop. */
    function removeOrphanGiftWrap() {
      const wrap = dialog.querySelector('[data-cart-drawer-gift-wrap]');
      if (!wrap || !wrap.hasAttribute('data-gift-wrap-orphan')) return;
      const keys = wrap.dataset.giftWrapKeys || '';
      if (!keys || targets.has(GIFT_KEY) || orphanAttempted === keys) return;
      orphanAttempted = keys;
      targets.set(GIFT_KEY, 0);
      runQueue();
    }

    function applySectionHtml(html, options) {
      options = options || {};
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const focus = captureFocus();
      applyFragment(doc, '[data-cart-drawer-shipping]');
      applyFragment(doc, '[data-cart-drawer-items]');
      applyFragment(doc, '[data-cart-drawer-gift-wrap]');
      applyFragment(doc, '[data-cart-drawer-footer]');
      reapplyPendingTargets();
      restoreFocus(focus);
      if (options.announce) announce();
      removeOrphanGiftWrap();
    }

    async function refreshUpsell(cartData) {
      const upsell = document.querySelector('[data-cart-drawer-upsell]');
      if (!upsell) return;
      // Seed from the first real item, never from the gift wrap line.
      const seed = (cartData.items || []).find((item) => !isGiftWrapItem(item));
      if (!seed || !recommendationsBase) {
        upsell.innerHTML = '';
        return;
      }
      try {
        const upsellRes = await fetch(recommendationsBase + '&product_id=' + seed.product_id);
        const upsellHtml = await upsellRes.text();
        const upsellDoc = new DOMParser().parseFromString(upsellHtml, 'text/html');
        applyFragment(upsellDoc, '[data-cart-drawer-upsell]');
      } catch (error) {}
    }

    function setLoading(delta) {
      loadingCount = Math.max(0, loadingCount + delta);
      dialog.classList.toggle('is-loading', loadingCount > 0);
    }

    async function refreshCartDrawer(options) {
      options = options || {};
      const seq = ++requestSeq;
      if (queueRunning) resyncAfterQueue = true;
      setLoading(1);
      const controller = window.AbortController ? new AbortController() : null;
      const timeout = controller ? setTimeout(() => controller.abort(), REFRESH_TIMEOUT_MS) : null;
      const signal = controller ? controller.signal : undefined;

      try {
        const [cartRes, sectionRes] = await Promise.all([
          fetch(routesRoot() + 'cart.js', { headers: { Accept: 'application/json' }, signal: signal }),
          fetch(cartUrl + '?section_id=' + encodeURIComponent(sectionId), { signal: signal }),
        ]);
        if (!cartRes.ok || !sectionRes.ok) throw new Error('cart refresh failed');
        const cartData = await cartRes.json();
        const sectionHtml = await sectionRes.text();

        if (seq > appliedSeq) {
          appliedSeq = seq;
          applySectionHtml(sectionHtml, options);
          syncHeaderCount(itemCount(cartData));
          refreshUpsell(cartData);
        }
      } catch (error) {
        // Leave existing drawer content in place on a network failure/timeout.
      } finally {
        clearTimeout(timeout);
        setLoading(-1);
      }

      if (options.open) window.openDialogAnimated(dialog);
    }

    /** Builds the request for one queue entry, or null when there is
        nothing to send (e.g. removing wrap that is no longer in the cart). */
    function buildRequest(key, value) {
      if (key === FIELDS_KEY) {
        return { path: 'cart/update.js', body: Object.assign({}, value), keepalive: true };
      }
      if (key === GIFT_KEY) {
        const updates = {};
        if (value > 0) {
          const toggle = giftToggle();
          if (toggle && toggle.dataset.variantId) updates[toggle.dataset.variantId] = 1;
        } else {
          // Remove by line key, not variant id: unambiguous even if the
          // wrap variant somehow sits on more than one line.
          const wrap = dialog.querySelector('[data-cart-drawer-gift-wrap]');
          const keys = ((wrap && wrap.dataset.giftWrapKeys) || '').split(',').filter(Boolean);
          keys.forEach((lineKey) => {
            updates[lineKey] = 0;
          });
        }
        if (!Object.keys(updates).length) return null;
        return { path: 'cart/update.js', body: { updates: updates } };
      }
      return { path: 'cart/change.js', body: { id: key, quantity: value } };
    }

    async function postChange(key, value) {
      const request = buildRequest(key, value);
      if (!request) return { ok: true, data: null };
      request.body.sections = [sectionId];
      request.body.sections_url = window.location.pathname;
      const response = await fetch(routesRoot() + request.path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(request.body),
        // Field saves can fire on blur as the shopper navigates away.
        keepalive: !!request.keepalive,
      });
      let data = null;
      try {
        data = await response.json();
      } catch (error) {}
      return { ok: response.ok && !!data, data: data };
    }

    async function runQueue() {
      if (queueRunning) return;
      queueRunning = true;

      let lastCart = null;
      let lastSeq = 0;
      let failed = false;
      let mutated = false;

      while (targets.size > 0) {
        const [key, value] = targets.entries().next().value;
        // Field saves happen while typing; don't dim the drawer for them.
        dialog.classList.toggle('is-updating', key !== FIELDS_KEY);
        let result;
        const seq = ++requestSeq;
        try {
          result = await postChange(key, value);
        } catch (error) {
          result = { ok: false, data: null };
        }

        if (result.ok) {
          if (result.data) {
            lastCart = result.data;
            lastSeq = seq;
            cartPageDirty = true;
          }
          if (key !== FIELDS_KEY) mutated = true;
          // A newer target for this key arrived while the request was in
          // flight: keep the entry so the loop sends the newer target.
          if (targets.get(key) === value) targets.delete(key);
        } else {
          failed = true;
          targets.delete(key);
          if (key === GIFT_KEY) {
            const toggle = giftToggle();
            if (toggle) {
              toggle.checked = !(value > 0);
              toggle.disabled = false;
            }
          }
          const data = result.data || {};
          showError(data.description || data.message);
        }
      }

      queueRunning = false;
      dialog.classList.remove('is-updating');

      const html = lastCart && lastCart.sections && lastCart.sections[sectionId];
      const needsResync = failed || !html || resyncAfterQueue || lastSeq <= appliedSeq;
      resyncAfterQueue = false;
      if (html && !failed && lastSeq > appliedSeq) {
        appliedSeq = lastSeq;
        applySectionHtml(html, { announce: mutated && !needsResync });
        syncHeaderCount(itemCount(lastCart));
        refreshUpsell(lastCart);
      }
      if (needsResync) {
        // A failed or section-less response, or a refresh that overlapped
        // the queue (its answer may predate the final POST): drop any such
        // in-flight refresh and resync once from the server, sent after
        // every POST, so the drawer ends on the cart's real state.
        appliedSeq = requestSeq;
        await refreshCartDrawer({ announce: mutated });
      }
      // Never leave the toggle disabled once nothing is pending for it,
      // even if both the POST and the resync failed.
      const toggle = giftToggle();
      if (toggle && !targets.has(GIFT_KEY)) toggle.disabled = false;
    }

    // Gift message (cart attribute) and order note: staged while typing and
    // queued after a debounce, or immediately on blur. Queued saves merge
    // into one entry, and the queue sends them in order with every other
    // cart write. The fields are also tied to the checkout form
    // (form="CartDrawerCheckout"), so checkout always posts the latest text
    // even if a save is still pending.
    let stagedFields = null;
    let saveTimer = null;
    const SAVE_DELAY_MS = 700;

    function stageField(field) {
      stagedFields = stagedFields || {};
      if (field.hasAttribute('data-cart-note')) {
        stagedFields.note = field.value;
      } else if (field.dataset.cartAttribute) {
        stagedFields.attributes = Object.assign({}, stagedFields.attributes, {
          [field.dataset.cartAttribute]: field.value,
        });
      }
    }

    function flushFields() {
      clearTimeout(saveTimer);
      if (!stagedFields) return;
      const previous = targets.get(FIELDS_KEY) || {};
      const next = Object.assign({}, previous, stagedFields);
      if (previous.attributes || stagedFields.attributes) {
        next.attributes = Object.assign({}, previous.attributes, stagedFields.attributes);
      }
      stagedFields = null;
      // Always a new object, so an in-flight save of the old one is
      // followed by this one (see the identity check in runQueue).
      targets.set(FIELDS_KEY, next);
      runQueue();
    }

    dialog.addEventListener('input', (event) => {
      const field = event.target.closest('[data-cart-attribute], [data-cart-note]');
      if (!field) return;
      stageField(field);
      clearTimeout(saveTimer);
      saveTimer = setTimeout(flushFields, SAVE_DELAY_MS);
    });

    dialog.addEventListener('focusout', (event) => {
      const field = event.target.closest('[data-cart-attribute], [data-cart-note]');
      if (!field) return;
      stageField(field);
      flushFields();
    });

    dialog.addEventListener('change', (event) => {
      const toggle = event.target.closest('[data-gift-wrap-toggle]');
      if (!toggle) return;
      clearError();
      toggle.disabled = true;
      targets.set(GIFT_KEY, toggle.checked ? 1 : 0);
      runQueue();
    });

    if (onCartPage) {
      dialog.addEventListener('close', () => {
        if (cartPageDirty) window.location.reload();
      });
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-dialog-open="cart-drawer"]')) {
        refreshCartDrawer();
        return;
      }

      const incBtn = event.target.closest('[data-qty-increase]');
      const decBtn = event.target.closest('[data-qty-decrease]');
      const bumpBtn = incBtn || decBtn;
      if (!bumpBtn || !dialog.contains(bumpBtn)) return;

      const lineKey = bumpBtn.dataset.lineKey;
      const line = bumpBtn.closest('[data-cart-line]');
      const qtyEl = line && line.querySelector('[data-qty-value]');
      const currentQty = targets.has(lineKey) ? targets.get(lineKey) : parseInt(qtyEl ? qtyEl.textContent : '0', 10) || 0;
      const nextQty = incBtn ? currentQty + 1 : Math.max(0, currentQty - 1);
      if (nextQty === currentQty) return;

      clearError();
      targets.set(lineKey, nextQty);
      if (qtyEl) qtyEl.textContent = nextQty;
      if (line) line.classList.add('is-pending');
      runQueue();
    });

    document.addEventListener('cart:refresh', (event) => {
      clearError();
      // Something outside the drawer (add to cart) changed the cart.
      cartPageDirty = true;
      refreshCartDrawer({ open: !!(event.detail && event.detail.open) });
    });

    // A cart left holding only gift wrap (e.g. from another tab) on load.
    removeOrphanGiftWrap();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    // Gift wrap toggle: submit the whole cart form as an Update so nothing
    // else on the page (quantities, gift message, note) is lost.
    document.addEventListener('change', (event) => {
      const toggle = event.target.closest('[data-cart-page-gift-wrap]');
      if (!toggle || toggle.disabled) return;
      const form = toggle.form || document.getElementById('CartPageForm');
      if (!form) return;

      if (toggle.checked) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'updates[' + toggle.dataset.variantId + ']';
        input.value = '1';
        form.appendChild(input);
      } else {
        // Remove by line key: each wrap line's own quantity input.
        form.querySelectorAll('[data-cart-page-gift-wrap-qty]').forEach((input) => {
          input.value = '0';
        });
      }

      toggle.disabled = true;
      const updateButton = form.querySelector('[data-cart-page-update]');
      if (form.requestSubmit) {
        form.requestSubmit(updateButton || undefined);
      } else if (updateButton) {
        updateButton.click();
      } else {
        form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  class CollectionView extends HTMLElement {
    connectedCallback() {
      const stored = this.readDensity();
      if (stored) {
        this.dataset.cols = stored;
      }
      this.updateSwatches();

      this.querySelectorAll('[data-cols-btn]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.dataset.cols = button.dataset.colsBtn;
          this.writeDensity(button.dataset.colsBtn);
          this.updateSwatches();
        });
      });

      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.filterPanel = this.querySelector('[data-filter-panel]');
      this.filterToggle?.addEventListener('click', () => {
        const open = this.filterToggle.getAttribute('aria-expanded') !== 'true';
        this.filterToggle.setAttribute('aria-expanded', String(open));
        this.filterPanel?.classList.toggle('is-open', open);
      });

      // Sort select submits its own GET form (which carries the active
      // filters as hidden inputs) as soon as the choice changes.
      this.querySelectorAll('select[data-auto-submit]').forEach((select) => {
        select.addEventListener('change', () => {
          const form = select.form;
          if (!form) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });
    }

    // Storage can throw (private mode, blocked site data): the density
    // toggle then simply doesn't persist.
    readDensity() {
      try {
        return window.localStorage.getItem('collection-density');
      } catch (error) {
        return null;
      }
    }

    writeDensity(value) {
      try {
        window.localStorage.setItem('collection-density', value);
      } catch (error) {
        /* not persisted */
      }
    }

    updateSwatches() {
      const cols = Number(this.dataset.cols || 3);
      this.querySelectorAll('[data-cols-btn]').forEach((button) => {
        button.classList.toggle('is-filled', cols >= Number(button.dataset.colsBtn));
      });
    }
  }

  if (!customElements.get('collection-view')) {
    customElements.define('collection-view', CollectionView);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gift-guide')) {
    class GiftGuide extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (!this.tabs.length) return;

        this.onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.select(tab, false);
        };

        this.onKeydown = (event) => {
          const current = this.tabs.indexOf(event.target);
          if (current === -1) return;
          let next = null;
          if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === null) return;
          event.preventDefault();
          this.select(this.tabs[next], true);
        };

        this.onBlockSelect = (event) => {
          const tab = this.tabs.find((t) => t.dataset.blockId === event.detail.blockId);
          if (tab) this.select(tab, false);
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(tab, focus) {
        this.tabs.forEach((t) => {
          const selected = t === tab;
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel && window.initScrollReveal) window.initScrollReveal(panel);
      }
    }

    customElements.define('gift-guide', GiftGuide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      if (opener.tagName === 'A') event.preventDefault();
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog) window.openDialogAnimated(dialog);
      return;
    }

    const closer = event.target.closest('[data-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) window.closeDialogAnimated(dialog);
      return;
    }

    if (event.target.tagName === 'DIALOG' && event.target.open) {
      window.closeDialogAnimated(event.target);
    }
  });

  /* Desktop disclosure navigation. Panels open on hover (with a short
     intent delay, pointer devices only) and on the chevron button
     (click / Enter / Space). Escape, focus leaving the item and clicks
     outside close them. A panel opened by click or keyboard stays open
     when the pointer leaves. */
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-menu-item]'));
      this.timers = new Map();
      this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

      this.items.forEach((item) => {
        const toggle = item.querySelector('[data-menu-toggle]');
        toggle.addEventListener('click', () => {
          if (item.classList.contains('is-open') && item.dataset.openedBy !== 'hover') {
            this.close(item);
          } else {
            this.open(item, 'click');
          }
        });
        item.addEventListener('mouseenter', () => {
          if (!this.hoverQuery.matches) return;
          this.schedule(item, () => this.open(item, 'hover'), 120);
        });
        item.addEventListener('mouseleave', () => {
          if (!this.hoverQuery.matches) return;
          if (item.classList.contains('is-open') && item.dataset.openedBy !== 'hover') {
            this.cancel(item);
            return;
          }
          this.schedule(item, () => this.close(item), 220);
        });
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) this.close(item);
        });
      });

      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.closeAll();
      };
      this.onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        const openItem = this.items.find((item) => item.classList.contains('is-open'));
        if (!openItem) return;
        const hadFocus = openItem.contains(document.activeElement);
        this.close(openItem);
        if (hadFocus) openItem.querySelector('[data-menu-toggle]').focus();
      };
      this.onBlockSelect = (event) => {
        const item = this.items.find((candidate) => candidate.contains(event.target));
        if (item) this.open(item, 'editor');
      };
      this.onBlockDeselect = (event) => {
        const item = this.items.find((candidate) => candidate.contains(event.target));
        if (item) this.close(item);
      };

      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.timers.forEach((timer) => clearTimeout(timer));
      this.timers.clear();
    }

    schedule(item, callback, delay) {
      this.cancel(item);
      this.timers.set(item, setTimeout(callback, delay));
    }

    cancel(item) {
      clearTimeout(this.timers.get(item));
      this.timers.delete(item);
    }

    open(item, source) {
      this.cancel(item);
      this.items.forEach((other) => {
        if (other !== item) this.close(other);
      });
      item.dataset.openedBy = source;
      item.classList.add('is-open');
      item.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', 'true');
    }

    close(item) {
      this.cancel(item);
      if (!item.classList.contains('is-open')) return;
      delete item.dataset.openedBy;
      item.classList.remove('is-open');
      item.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', 'false');
    }

    closeAll() {
      this.items.forEach((item) => this.close(item));
    }
  }

  if (!customElements.get('header-menu')) customElements.define('header-menu', HeaderMenu);

  // The nav row makes the desktop header height content-dependent, so measure it.
  (() => {
    const header = document.querySelector('.site-header');
    if (!header || !('ResizeObserver' in window)) return;
    new ResizeObserver(() => {
      document.documentElement.style.setProperty('--header-sticky-height', `${header.offsetHeight}px`);
    }).observe(header);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              window.initScrollReveal && window.initScrollReveal(this);
            }
          })
          .catch(() => {});
      };

      new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumen-video')) {
    class LumenVideo extends HTMLElement {
      connectedCallback() {
        this.playButton = this.querySelector('[data-video-play]');
        this.toggleButton = this.querySelector('[data-video-toggle]');
        this.video = this.querySelector('video');

        if (this.playButton) {
          this.playButton.addEventListener('click', () => this.loadEmbed());
        }

        if (this.toggleButton && this.video) {
          this.toggleButton.addEventListener('click', () => this.togglePlayback());
        }
      }

      loadEmbed() {
        const src = this.dataset.embedSrc;
        if (!src) return;
        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = this.dataset.title || 'Video';
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        this.querySelector('.video-section__poster')?.remove();
        this.playButton.remove();
        this.appendChild(iframe);
        iframe.focus();
      }

      togglePlayback() {
        if (this.video.paused) {
          this.video.play();
          this.toggleButton.setAttribute('aria-pressed', 'false');
        } else {
          this.video.pause();
          this.toggleButton.setAttribute('aria-pressed', 'true');
        }
      }
    }

    customElements.define('lumen-video', LumenVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
